export default function nl2br(text) {
   if (!text) return text
   return text.replace(/\n/gi, "<br />")
}
